import { TabMenu } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { useSelectedUser } from 'hooks/useSelectedUser/useSelectedUser';
import { UserDetailsTabEnum } from 'context/selectedUser/selectedUserContext/SelectedUserContext.enum';

import { UserActions } from './userActions/UserActions';
import { UserDetailsProps } from './UserDetails.types';
import { UserBasicDetailsContainer } from './userBasicDetails/UserBasicDetailsContainer';
import { UserDetailsTabDescriptionEnum } from './UserDetails.enum';
import { UserPersonalDetailsContainer } from './userPersonalDetails/UserPersonalDetailsContainer';

export const UserDetails = ({
  isLoadingUpdateUser,
  selectedUser,
  onUpdateUserSubmit,
  errorFields,
}: UserDetailsProps) => {
  const { formatMessage } = useLocale();
  const { selectedUserDetailsTab, setSelectedUserDetailsTab } = useSelectedUser();

  return (
    <>
      <UserActions />

      <TabMenu.Wrapper
        selectedValue={selectedUserDetailsTab}
        setSelectedValue={setSelectedUserDetailsTab}
        tabsValues={UserDetailsTabEnum}
        tabsDescriptions={{
          [UserDetailsTabEnum.BASIC]: formatMessage({ id: UserDetailsTabDescriptionEnum.BASIC }),
          [UserDetailsTabEnum.PERSONAL]: formatMessage({ id: UserDetailsTabDescriptionEnum.PERSONAL }),
        }}
      >
        <TabMenu.Panel value={UserDetailsTabEnum.BASIC}>
          <UserBasicDetailsContainer
            isLoadingUpdateUser={isLoadingUpdateUser}
            selectedUser={selectedUser}
            onUpdateUserSubmit={onUpdateUserSubmit}
            errorFields={errorFields}
          />
        </TabMenu.Panel>
        <TabMenu.Panel value={UserDetailsTabEnum.PERSONAL}>
          <UserPersonalDetailsContainer
            isLoadingUpdateUser={isLoadingUpdateUser}
            selectedUser={selectedUser}
            onUpdateUserSubmit={onUpdateUserSubmit}
            errorFields={errorFields}
          />
        </TabMenu.Panel>
      </TabMenu.Wrapper>
    </>
  );
};
